module.exports = __webpack_public_path__ + "img/Group 102941.ef955ee3.svg";